import styles from './rejected-login-grid.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useTableConfigHook } from '../../requestUtils';
import { CreateHeaders, HeaderSizeEnum, SumRows, TableProductsFilterProps, textHeader } from '@frontend-workspace/react-shared-lib';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { IDeniedLogon } from '../../_models/denied-logon';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface RejectedLoginGridProps {
  rejectedLogins: IDeniedLogon[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  dateRange: DateRange<Date>,
  forGroup: boolean,
  productFilter: TableProductsFilterProps,
  toggleForGroup: () => void,
  onRefresh: () => void,
  isLoading: boolean
}

const persentRenderer = (params: ValueFormatterParams) => {
  if (params.data.isSummary) return "";
  return params.value + '%';
};

export function RejectedLoginGrid(props: RejectedLoginGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("rejectedLogins");

  return (
    <WebkuaTable
      isLoading={props.isLoading}
      productsFilter={props.productFilter}
      onRefresh={props.onRefresh}
      data={props.rejectedLogins}
      headers={CreateHeaders([
        textHeader("companyName", t("standard.company"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("product", t("standard.product"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("licenseModel", t("standard.licenseModel"), HeaderSizeEnum.LARGE),
        textHeader("newLicensing", t("rejectedLoginGrid.licensingSystem"), HeaderSizeEnum.MEDIUM),
        textHeader("seats", t("standard.seats"), HeaderSizeEnum.SMALL, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("approved", t("rejectedLoginGrid.approved"), HeaderSizeEnum.SMALL, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header",
          summary: SumRows
        }),
        textHeader("rejected", t("rejectedLoginGrid.rejected"), HeaderSizeEnum.SMALL, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header",
          summary: SumRows
        }),
        textHeader("rejectedPersent", t("rejectedLoginGrid.rejectedPersent"), HeaderSizeEnum.SMALL, {
          renderer: persentRenderer,
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        })
      ])}
      tableConfig={tableConfig}
      pageSize={15}
      tableFilters={[{
        label: t("standard.showForGroup"),
        checked: props.forGroup,
        onChange: props.toggleForGroup
      }]}
      dateRange={props.dateRange}
      onSetDateRange={props.onDateChange}
    />
  );
}

export default RejectedLoginGrid;